// Include Stylesheet
require("../../css/src/stylesheet.scss");

// Include Offset Base Resources
require("OffsetBaseResources");

// Configure Offset APIs
// This should come after FigureBaseResources so it can override the default config if needed
require("./offset.config.js");

// Custom Site Stuff
require("./theme.js");

// Google Places Autocomplete
require("./place-autocomplete.js");

// Material Design
//require("./material-design.js");

// Load via script tag:
// require('script-loader!./scroller.js')

// Expose a variable from a library:
// const scroller = require('expose-loader?scroller!./scroller.js')

// Offset Cantina
const { defineElements } = require("offset-cantina");
defineElements();

// Offset Consent
const { ConsentManager, ConsentUI } = require("offset-consent");
window.OffsetConsent = new ConsentUI(new ConsentManager(window.OFFSET.consent));
window.OffsetConsent.mount();
